<template>
  <div @click="methods.toggle('isNavbar')" class="d-flex">
    <button type="button" class="tconnav tconnav-menu--arrow tconnav-menu--arrowleft" :class="{'tconnav-transform':data.navbar.navActive === 'isNavbar'}">
      <span class="tconnav-menu__lines" aria-hidden="true"></span>
      <span class="tconnav-visuallyhidden">toggle menu</span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'navbar-toggle',
  inject: {
    methods: {
      default: {}
    },
    data: {
      default: {}
    }
  },
}
</script>

<style lang="less" scoped>
@import (reference) "../../../assets/css/variable.less";
.tconnav {
  border: none;
  position: relative;
  transition: 0.3s;
  user-select: none;
  background: transparent;
  outline: none;
  display: none;
  margin-top: -4px;
  margin-right: 10px;
}

.tconnav > * {
  display: block;
}

.tconnav:hover,
.tconnav:focus {
  outline: none;
}

.tconnav::-moz-focus-inner {
  border: 0;
}

.tconnav-menu__lines {
  display: inline-block;
  height: 2px;
  width: 30px;
  border-radius: 2.85714px;
  transition: 0.3s;
  background: #999;
  position: relative;
}

.tconnav-menu__lines::before,
.tconnav-menu__lines::after {
  display: inline-block;
  height: 2px;
  width: 30px;
  border-radius: 2.85714px;
  transition: 0.3s;
  background: #999;
  content: "";
  position: absolute;
  right: 0;
  transform-origin: 18.85714px center;
  width: 100%;
}

.tconnav-menu__lines::before {
  top: 10px;
}

.tconnav-menu__lines::after {
  top: -10px;
}

.tconnav-transform .tconnav-menu__lines {
  transform: scale3d(0.8, 0.8, 0.8);
}

.tconnav-menu--arrow,
.tconnav-menu--arrowleft {
  width: auto;
}

.tconnav-menu--arrow.tconnav-transform .tconnav-menu__lines::before,
.tconnav-transform.tconnav-menu--arrowleft .tconnav-menu__lines::before,
.tconnav-menu--arrow.tconnav-transform .tconnav-menu__lines::after,
.tconnav-transform.tconnav-menu--arrowleft .tconnav-menu__lines::after {
  top: 0;
  width: 20.22222px;
}

.tconnav-menu--arrow.tconnav-transform .tconnav-menu__lines::before,
.tconnav-transform.tconnav-menu--arrowleft .tconnav-menu__lines::before {
  transform: rotate3d(0, 0, 1, 45deg);
}

.tconnav-menu--arrow.tconnav-transform .tconnav-menu__lines::after,
.tconnav-transform.tconnav-menu--arrowleft .tconnav-menu__lines::after {
  transform: rotate3d(0, 0, 1, -45deg);
}

.tconnav-visuallyhidden {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

.tconnav-visuallyhidden:active,
.tconnav-visuallyhidden:focus {
  clip: auto;
  height: auto;
  margin: 0;
  overflow: visible;
  position: static;
  width: auto;
}

.tconnav-transform {
  position: fixed;
  right: 15px;
  top: 15px;
  z-index: 9999;
}

@media screen and (max-width: 992px) {
  .tconnav {
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ui/navbar/navbar-toggle.vue